import { useQuery } from "@tanstack/react-query";
import type { QueryClient } from "@tanstack/react-query";
import { api } from "utils/api";

export const favoriteExpertQueryKey = (expertId: string) =>
  ["favorite-expert", expertId] as const;

export const setFavoriteExpertCache = (
  queryClient: QueryClient,
  expertId: string,
  isFavorite: boolean
) => {
  queryClient.setQueryData(favoriteExpertQueryKey(expertId), isFavorite);
};

export default function useFavoriteExpert(expertId: string) {
  const {
    data: isFavorite,
    isLoading: favoriteExpertLoading,
    refetch: getFavoriteExpert,
  } = useQuery(
    favoriteExpertQueryKey(expertId),
    () => api.get(`/users/v1/users/is-favorite/${expertId}`),
    {
      enabled: !!expertId,
    }
  );

  return {
    isFavorite,
    favoriteExpertLoading,
    getFavoriteExpert,
  };
}
